import {Component, HostListener, OnInit} from '@angular/core';
import { Encoder } from '../../model/encoder';
import { EncodersService } from '../../services/encoders.service';
import { EncoderFilters } from '../../model/filters/encoder-filters';
import { SortOrder } from '../../model/sort-order';
import { TenantsService } from '../../services/tenants.service';
import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonMessagesService } from '../../services/common-messages.service';
import { AuthGuard } from '../../common/auth-guard.service';
import { Tenant } from '../../model/tenant';
import {FiltersService} from "../../services/filters.service";

@Component({
  selector: 'app-encoders',
  templateUrl: './encoders.component.html',
  styleUrls: ['./encoders.component.scss']
})
export class EncodersComponent implements OnInit {

  public encoders: Encoder[];
  public totalEncoders: number;
  public loadingEncoders: boolean;
  public tenants: Tenant[];

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: EncoderFilters;
  public displayFailedDeleteList: boolean;
  public failedDeleteList: any[];
  public filtersFilled: boolean;

  constructor(private encodersService: EncodersService,
              private tenantsService: TenantsService,
              private messageService: MessageService,
              private i18n: TranslocoService,
              private confirmationService: ConfirmationService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<EncoderFilters>) {
    this.currentFilters = new EncoderFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.encoders = new Array(this.rows);
    if (this.authGuardService.superAdminRequired()) {
      this.tenantsService.getTenants().subscribe(response => {
        this.tenants = response.tenants
          .sort((a, b) => a.name > b.name ? 1 : -1);
        Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
      });
    } else {
      Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    }
  }

  private loadEncoders(offset?: number, limit?: number): void {
    this.loadingEncoders = true;
    this.encoders = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.encodersService.getEncoders(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters: this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.encoders = response.encoders;
        this.totalEncoders = response.totalElements;
        this.loadingEncoders = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadEncoders(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new EncoderFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true){
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadEncoders(this.first / this.rows, this.rows);
  }

  confirmAndDelete(encoder: Encoder): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteEncoder(encoder.tenant.uuid, encoder.name);
    });
  }

  deleteEncoder(tenantUuid: string, name: string): void {
    this.tenantsService.deleteTenantEncoder(tenantUuid, name).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadEncoders(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) { return; }
    const identifiers = this.selected.map(item => ({tenantUuid: item.tenant.uuid, name: item.name}));

    this.encodersService.deleteEncoders(identifiers).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadEncoders(this.first / this.rows, this.rows);
    }, error => {
      this.failedDeleteList = error.error.encodersBeingUsed;
      this.displayFailedDeleteList = true;
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  trimFieldsForm(filters: EncoderFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
